import { SvgIcon, SvgIconProps } from '@mui/material';
import { emerald, white } from '@/lib/colours';

export function ListAltIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2925_1143)">
          <path d="M0 0.000976562H32V32.001H0V0.000976562Z" fill={white[900]} />
          <path
            d="M16 12.001H21.3333C22.0667 12.001 22.6667 11.401 22.6667 10.6676C22.6667 9.93431 22.0667 9.33431 21.3333 9.33431H16C15.2667 9.33431 14.6667 9.93431 14.6667 10.6676C14.6667 11.401 15.2667 12.001 16 12.001ZM16 17.3343H21.3333C22.0667 17.3343 22.6667 16.7343 22.6667 16.001C22.6667 15.2676 22.0667 14.6676 21.3333 14.6676H16C15.2667 14.6676 14.6667 15.2676 14.6667 16.001C14.6667 16.7343 15.2667 17.3343 16 17.3343ZM16 22.6676H21.3333C22.0667 22.6676 22.6667 22.0676 22.6667 21.3343C22.6667 20.601 22.0667 20.001 21.3333 20.001H16C15.2667 20.001 14.6667 20.601 14.6667 21.3343C14.6667 22.0676 15.2667 22.6676 16 22.6676ZM9.33333 9.33431H12V12.001H9.33333V9.33431ZM9.33333 14.6676H12V17.3343H9.33333V14.6676ZM9.33333 20.001H12V22.6676H9.33333V20.001ZM26.6667 4.00098H5.33333C4.6 4.00098 4 4.60098 4 5.33431V26.6676C4 27.401 4.6 28.001 5.33333 28.001H26.6667C27.4 28.001 28 27.401 28 26.6676V5.33431C28 4.60098 27.4 4.00098 26.6667 4.00098ZM25.3333 25.3343H6.66667V6.66764H25.3333V25.3343Z"
            fill={emerald[600]}
          />
        </g>
        <defs>
          <clipPath id="clip0_2925_1143">
            <rect
              width="32"
              height="32"
              fill={white[900]}
              transform="translate(0 0.000976562)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
